const CONSENT_KEY = "sortie_analytics_consent"
const ALLOWED_UTM_PARAMETERS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"]
const ALLOWED_CTA_PLACEMENTS = new Set([
  "hero",
  "nav",
  "pricing",
  "footer",
  "ai_email_organizer_hero",
  "ai_email_organizer_bottom",
  "gmail_automation_guide",
  "gmail_filters_guide",
  "gmail_labels_guide",
  "auto_label_gmail",
  "gmail_email_sorter",
  "gmail_filters_vs_ai",
  "email_triage",
  "inbox_zero_gmail",
  "auto_archive_gmail"
])

let configuredMeasurementId = null

function measurementId() {
  return document.querySelector('meta[name="google-analytics-id"]')?.content
}

function consentChoice() {
  try {
    return window.localStorage.getItem(CONSENT_KEY)
  } catch (_error) {
    return null
  }
}

function saveConsentChoice(choice) {
  try {
    window.localStorage.setItem(CONSENT_KEY, choice)
  } catch (_error) {
    // A blocked storage API leaves the choice scoped to this page load.
  }
}

function clearConsentChoice() {
  try {
    window.localStorage.removeItem(CONSENT_KEY)
  } catch (_error) {
    // The banner can still be shown for this page load.
  }
}

function setBannerVisibility(visible) {
  document.querySelectorAll("[data-analytics-consent-banner]").forEach((banner) => {
    banner.classList.toggle("hidden", !visible)
  })
}

function prepareGoogleTag() {
  window.dataLayer = window.dataLayer || []
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments) }
}

function grantAnalyticsConsent() {
  window.gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied"
  })
  window.gtag("consent", "update", { analytics_storage: "granted" })
}

function loadGoogleTag(id) {
  if (configuredMeasurementId === id) return false

  prepareGoogleTag()
  grantAnalyticsConsent()
  window.gtag("js", new Date())
  window.gtag("config", id, {
    allow_ad_personalization_signals: false,
    allow_google_signals: false,
    send_page_view: false
  })

  const script = document.createElement("script")
  script.async = true
  script.dataset.googleAnalyticsId = id
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`
  document.head.appendChild(script)
  configuredMeasurementId = id

  return true
}

function analyticsPageLocation() {
  const canonical = document.querySelector('link[rel="canonical"]')
  if (!canonical) return null

  const location = new URL(canonical.href)
  const currentLocation = new URL(window.location.href)

  ALLOWED_UTM_PARAMETERS.forEach((parameter) => {
    const value = currentLocation.searchParams.get(parameter)
    if (value) location.searchParams.set(parameter, value.slice(0, 100))
  })

  return location
}

function analyticsReferrer() {
  if (!document.referrer) return undefined

  try {
    const referrer = new URL(document.referrer)
    return referrer.origin === window.location.origin ? `${referrer.origin}${referrer.pathname}` : referrer.origin
  } catch (_error) {
    return undefined
  }
}

function sendPageView() {
  if (consentChoice() !== "accepted" || !configuredMeasurementId) return

  const location = analyticsPageLocation()
  if (!location) return

  window.gtag("event", "page_view", {
    page_location: location.toString(),
    page_path: location.pathname,
    page_referrer: analyticsReferrer(),
    page_title: document.title
  })
}

function startAnalytics() {
  const id = measurementId()
  if (!id || consentChoice() !== "accepted") return false

  return loadGoogleTag(id)
}

function deleteGoogleAnalyticsCookies() {
  const domains = [window.location.hostname, `.${window.location.hostname}`]

  document.cookie.split(";").forEach((cookie) => {
    const name = cookie.split("=")[0].trim()
    if (!name.startsWith("_ga")) return

    document.cookie = `${name}=; Max-Age=0; path=/`
    domains.forEach((domain) => {
      document.cookie = `${name}=; Max-Age=0; path=/; domain=${domain}`
    })
  })
}

document.addEventListener("turbo:load", () => {
  if (!measurementId()) return

  setBannerVisibility(consentChoice() === null)
  startAnalytics()
  sendPageView()
})

document.addEventListener("click", (event) => {
  const consentButton = event.target.closest("[data-analytics-consent-action]")
  if (consentButton) {
    const action = consentButton.dataset.analyticsConsentAction

    if (action === "manage") {
      clearConsentChoice()
      if (configuredMeasurementId) window.gtag("consent", "update", { analytics_storage: "denied" })
      setBannerVisibility(true)
      return
    }

    if (action === "accept") {
      saveConsentChoice("accepted")
      setBannerVisibility(false)
      if (configuredMeasurementId) window.gtag("consent", "update", { analytics_storage: "granted" })
      const newlyConfigured = startAnalytics()
      if (newlyConfigured) sendPageView()
      return
    }

    if (action === "decline") {
      saveConsentChoice("declined")
      setBannerVisibility(false)
      deleteGoogleAnalyticsCookies()

      if (configuredMeasurementId) {
        window.gtag("consent", "update", { analytics_storage: "denied" })
        window.location.reload()
      }
      return
    }
  }

  const signupLink = event.target.closest("[data-ga-signup-placement]")
  const placement = signupLink?.dataset.gaSignupPlacement
  if (!placement || !ALLOWED_CTA_PLACEMENTS.has(placement)) return
  if (consentChoice() !== "accepted" || !configuredMeasurementId) return

  window.gtag("event", "signup_cta_click", { cta_placement: placement })
})
